/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTurnoDto } from '../../models/create-turno-dto';
import { TurniResDto } from '../../models/turni-res-dto';

export interface TurniControllerCreateStruttura$Params {
  body: CreateTurnoDto;
}

export function turniControllerCreateStruttura(
  http: HttpClient,
  rootUrl: string,
  params: TurniControllerCreateStruttura$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurniResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    turniControllerCreateStruttura.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TurniResDto>;
      }),
    );
}

turniControllerCreateStruttura.PATH = '/admin/turni';
